import { render, staticRenderFns } from "./OrderMapCard.vue?vue&type=template&id=f1732b6a&scoped=true"
import script from "./OrderMapCard.vue?vue&type=script&lang=js"
export * from "./OrderMapCard.vue?vue&type=script&lang=js"
import style0 from "./OrderMapCard.vue?vue&type=style&index=0&id=f1732b6a&prod&lang=scss&scoped=true"
import style1 from "./OrderMapCard.vue?vue&type=style&index=1&id=f1732b6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1732b6a",
  null
  
)

export default component.exports